module.exports = __webpack_public_path__ + "img/11.6e6007bc.jpg";